import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Home, BookOpen, Newspaper, Star } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-strong">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" data-discover="true" className="flex items-center space-x-2">
            <img 
              src="/images/favicon.webp" 
              alt="Sterling Spins Logo" 
              className="w-10 h-10 rounded-lg"
            />
            <span className="text-2xl font-bold text-brown-900">Sterling Spins</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" data-discover="true" className="flex items-center space-x-1 text-brown-800 hover:text-brown-600 transition-colors">
              <Home className="w-4 h-4" />
              <span>Home</span>
            </Link>
            <Link to="/guides" data-discover="true" className="flex items-center space-x-1 text-brown-800 hover:text-brown-600 transition-colors">
              <BookOpen className="w-4 h-4" />
              <span>Guides</span>
            </Link>
            <Link to="/news" data-discover="true" className="flex items-center space-x-1 text-brown-800 hover:text-brown-600 transition-colors">
              <Newspaper className="w-4 h-4" />
              <span>News</span>
            </Link>
            <Link to="/reviews" data-discover="true" className="flex items-center space-x-1 text-brown-800 hover:text-brown-600 transition-colors">
              <Star className="w-4 h-4" />
              <span>Reviews</span>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-lg text-brown-900 hover:bg-white/30 transition-colors"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-2">
            <Link
              to="/"
              data-discover="true"
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center space-x-2 px-4 py-2 rounded-lg text-brown-800 hover:bg-white/30 transition-colors"
            >
              <Home className="w-4 h-4" />
              <span>Home</span>
            </Link>
            <Link
              to="/guides"
              data-discover="true"
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center space-x-2 px-4 py-2 rounded-lg text-brown-800 hover:bg-white/30 transition-colors"
            >
              <BookOpen className="w-4 h-4" />
              <span>Guides</span>
            </Link>
            <Link
              to="/news"
              data-discover="true"
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center space-x-2 px-4 py-2 rounded-lg text-brown-800 hover:bg-white/30 transition-colors"
            >
              <Newspaper className="w-4 h-4" />
              <span>News</span>
            </Link>
            <Link
              to="/reviews"
              data-discover="true"
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center space-x-2 px-4 py-2 rounded-lg text-brown-800 hover:bg-white/30 transition-colors"
            >
              <Star className="w-4 h-4" />
              <span>Reviews</span>
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;

